import React, { useEffect, useReducer, useState } from "react"
import PropTypes from "prop-types"

import classes from "utils/classes"
import Search from "../search"
import DropdownIcon from "./assets/dropdown.inline.svg"
import styles from "./cities.module.scss"

const Cities = ({ cities = [], totalCount = 0, onChange }) => {
  const [opened, toggleOpened] = useReducer(state => !state, false)
  const [selected, setSelected] = useState()
  const [items, setItems] = useState(cities)

  useEffect(() => {
    setItems(cities)
  }, [cities])

  useEffect(() => {
    if (!opened) {
      setItems(cities)
    }
  }, [opened])

  const handleSearch = search => {
    setItems(
      !search
        ? cities
        : cities.filter(
            item => item.city.toLowerCase().indexOf(search.toLowerCase()) > -1
          )
    )
  }

  const handleSelect = city => () => {
    setSelected(city)
    toggleOpened()
    onChange?.(city)
  }

  return (
    <div className={styles.cities}>
      <button
        onClick={toggleOpened}
        className={`${styles.toggler} ${opened ? styles.opened : ""}`}
        type="button"
      >
        {!selected ? "во всех городах" : selected.city}
        <DropdownIcon />
      </button>
      {opened && (
        <div className={styles.modal}>
          <Search onChange={handleSearch} className={styles.search} />
          <div className={styles.list}>
            <button
              onClick={handleSelect(null)}
              className={classes(styles.item, !selected && styles.selected)}
            >
              <div>Все города</div>
              <div className={styles.count}>{totalCount}</div>
            </button>
            {items.map(item => (
              <button
                key={item.id}
                onClick={handleSelect(item)}
                className={classes(
                  styles.item,
                  selected?.id === item.id && styles.selected
                )}
              >
                <div>{item.city}</div>
                <div className={styles.count}>{item.count || 0}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

Cities.propTypes = {
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      city: PropTypes.string,
      count: PropTypes.number,
    })
  ),
  onChange: PropTypes.func,
}

export default Cities
